import classNames from 'classnames';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

interface IProps {
  isDelete: boolean;
  gridTemplate: string;
}

const KioskItemSkeleton: FC<IProps> = ({ isDelete, gridTemplate }: IProps): JSX.Element => {
  return (
    <div className={classNames('kiosk-item mr-4', gridTemplate, { 'cursor-pointer': !isDelete })}>
      <div className="kiosk-item__element">
        <Skeleton width={20} height={16} />
      </div>

      <div className="kiosk-item__element">
        <Skeleton width="50%" height={16} />
      </div>

      <div className="kiosk-item__element">
        {isDelete ? (
          <Skeleton width={80} height={16} />
        ) : (
          <>
            <Skeleton width={50} height={30} style={{ borderRadius: 30 }} />
            <Skeleton width={25} height={25} />
          </>
        )}
      </div>
    </div>
  );
};

export default KioskItemSkeleton;
